// Central content for the portfolio.
export const MODEL = {
  firstName: "Fateh",
  lastName: "Bhinder",
  tagline: ["Fashion", "&", "Editorial", "Model"],
  location: "Based in Melbourne, Australia — Working Worldwide",
  intro:
    "Some people enter a room. Others change the atmosphere. I believe presence speaks louder than words. Through fashion, movement, and expression, I aim to create timeless imagery that feels effortless, memorable, and unmistakably mine.",
  stats: [
    { label: "Height", value: "185 cm" },
    { label: "Chest", value: "36\"" },
    { label: "Waist", value: "34\"" },
    { label: "Shoes", value: "US 11 · UK 10 · EU 45" },
    { label: "Hair", value: "Black" },
    { label: "Eyes", value: "Dark Brown" },
    { label: "Based", value: "Melbourne" },
  ],
  instagram: "@bbbhinderr",
  socials: [
    { label: "Instagram", href: "https://instagram.com/bbbhinderr" },
  ],
};

export const WORKS = [
  {
    title: "Leather Study",
    images: [
      { src: "/images/work-2.webp", w: 1504, h: 2000 },
      { src: "/images/work-2b.webp", w: 1504, h: 2000 },
    ],
  },
  {
    title: "Full Length",
    client: "Denim — Studio",
    images: [
      { src: "/images/work-10.jpeg", w: 1203, h: 1600 },
      { src: "/images/work-11.jpeg", w: 1203, h: 1600 },
    ],
  },
  {
    title: "Presence",
    images: [
      { src: "/images/work-13.webp", w: 1504, h: 2000 },
      { src: "/images/work-12.webp", w: 2000, h: 1340 },
    ],
  },
  {
    title: "Headshots",
    images: [
      { src: "/images/headshot-1.webp", w: 1504, h: 2000 },
      { src: "/images/headshot-2.webp", w: 1504, h: 2000 },
      { src: "/images/headshot-3.webp", w: 1504, h: 2000 },
    ],
  },
];

export const EXPERIENCE = [
  { year: "2025", role: "Editorial Feature", org: "Independent Publication", place: "Melbourne" },
  { year: "2025", role: "Menswear Campaign", org: "Contemporary Label", place: "Melbourne" },
  { year: "2024", role: "Runway — Ready to Wear", org: "Fashion Showcase", place: "Sydney" },
  { year: "2024", role: "Seasonal Lookbook", org: "Streetwear Brand", place: "Melbourne" },
  { year: "2023", role: "Studio Test & Portfolio", org: "Creative Direction", place: "Melbourne" },
];

export const HERO_IMAGE = "/images/hero.jpeg";
export const ABOUT_IMAGE = "/images/about-2.webp";

export const MARQUEE_ITEMS = [
  "Editorial",
  "Menswear",
  "Runway",
  "Campaign",
  "Melbourne",
  "Lookbook",
  "Studio",
  "Contemporary",
];
